import React, { Component } from "react";
import { connect } from "react-redux";
import { BlueBtn } from "components/Controls";
import {
  loadingSelector,
  activeStepDataSelector,
} from "containers/MultistepForm/selectors";
import { selectOffer } from "containers/MultistepForm/actions";

import Form from "./Form";

import "./styles.scss";

// Post-approval data for the fypn approval submit (Origin8 campaignID 16):
// identification, employer and bank name. Stored on the selected offer's
// additional_info_data and sent to the backend together with the debit card
// on the next step.
class FypnAdditionalInfoForm extends Component {
  state = {
    additionalData: {},
    valid: false,
  };

  buildRequestBody = () => {
    const { additionalData } = this.state;
    const { offer } = this.props;
    const additionalInfo = offer.additional_info_data || {};

    return {
      ...offer,
      additional_info_data: {
        ...additionalInfo,
        identification: {
          licenseNumber: additionalData.licenseNumber,
          licenseState: additionalData.licenseState,
        },
        employment: {
          employer: additionalData.employer,
          employerCity: additionalData.employerCity,
          employerState: additionalData.employerState,
          employerZip: additionalData.employerZip,
          workPhone: additionalData.workPhone,
          yearsAtEmployer: additionalData.yearsAtEmployer,
          monthsAtEmployer: additionalData.monthsAtEmployer,
        },
        bankAccount: {
          ...(additionalInfo.bankAccount || {}),
          bankName: additionalData.bankName,
        },
      },
    };
  };

  submitForm = (e) => {
    const { valid } = this.state;
    e.preventDefault();
    if (!valid) return;

    this.props.selectOffer({ selectedOffer: this.buildRequestBody() });
  };

  setAdditionalData = (data) => {
    this.setState({
      additionalData: data.data,
      valid: data.valid,
    });
  };

  render() {
    const { loading, activeStepData } = this.props;
    const { valid } = this.state;

    return (
      <div className="paypair-step-content">
        <div className="fypn-additional-info-form-container">
          <div className="fypn-additional-info-form">
            <div className="fypn-additional-info-form__header">
              <h2 className="fypn-additional-info-form__title">
                A few more details
              </h2>
              <p className="fypn-additional-info-form__subtitle">
                Some of our partners are requesting additional information to
                finalize your application.
              </p>
            </div>

            <div className="fypn-additional-info-form__body">
              {activeStepData && activeStepData.error && activeStepData.message && (
                <div className="fypn-additional-info-form__error-message">
                  {activeStepData.message || ""}
                </div>
              )}

              <Form onDataChange={this.setAdditionalData} />
            </div>

            <div className="fypn-additional-info-form__footer">
              <BlueBtn
                customClass="fypn-additional-info-form-submit-btn"
                disabled={!valid}
                loading={loading}
                onClick={this.submitForm}
              >
                Continue
              </BlueBtn>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  loading: loadingSelector()(state),
  offer: activeStepDataSelector()(state),
  activeStepData: activeStepDataSelector()(state),
});

const mapDistpatchToProps = (dispatch) => {
  return {
    selectOffer: (data) => dispatch(selectOffer(data)),
  };
};

FypnAdditionalInfoForm = connect(
  mapStateToProps,
  mapDistpatchToProps
)(FypnAdditionalInfoForm);

export default FypnAdditionalInfoForm;
